import service from '@/utils/server';
const modName='/coal/ship/';

//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'coalShipPageInfo',
    method: 'post',
    data
  });
};

//初始化更新对象
export const initUpdate = data => {
  return service({
    url: modName + 'editDetails',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/bd/coal/coalShip/api/index.js